export default "__VITE_ASSET__1y_7Bjv6__"